"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CommonConfig = {};
exports.default = CommonConfig;
//# sourceMappingURL=booking-common.config.js.map